import React, { useState, useEffect } from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import { PercentInput, DecimalInput } from "components/Global/FormikMaterial";

import { fieldTypes } from "../../constants";
import "./styles.css";

const LoanProceedsConstraintsModal = ({ open, modalType, handleCancel, setFieldValue, handleSave, values }) => {
  const { lpscMinDscr, lpscMaxLtv, lpscMinDebtYield, constraintId } = values;
  const [saveIsDisabled, setSaveIsDisabled] = useState(true);

  const constraint = {
    constraintId,
    minDscr: lpscMinDscr,
    maxLtv: lpscMaxLtv,
    minDebtYield: lpscMinDebtYield
  };

  useEffect(() => {
    setSaveIsDisabled(!(Boolean(lpscMinDscr) && Boolean(lpscMaxLtv) && Boolean(lpscMinDebtYield)));
  }, [lpscMinDscr, lpscMaxLtv, lpscMinDebtYield]);

  const fields = [
    {
      label: "MIN DSCR",
      fieldName: "lpscMinDscr",
      fieldType: fieldTypes.DECIMAL_INPUT,
      selectValue: "value",
      onChange: ({ target }) => {
        setFieldValue("lpscMinDscr", target.value);
      }
    },
    {
      label: "MAX LTV",
      fieldName: "lpscMaxLtv",
      fieldType: fieldTypes.PERCENT_INPUT,
      selectValue: "value",
      onChange: ({ target }) => {
        setFieldValue("lpscMaxLtv", target.value);
      }
    },
    {
      label: "MIN DEBT YIELD",
      fieldName: "lpscMinDebtYield",
      fieldType: fieldTypes.PERCENT_INPUT,
      selectValue: "value",
      onChange: ({ target }) => {
        setFieldValue("lpscMinDebtYield", target.value);
      }
    }
  ];

  return (
    <Dialog open={open} className="loan-proceeds-constraints-modal-wrapper">
      <DialogTitle className="loan-proceeds-constraints-modal-title">
        {modalType}
        {" "}
        constraints
      </DialogTitle>
      <DialogContent>
        <div className="loan-proceeds-constraints-modal-inputs-wrapper">
          {fields.map((field, idx) => ((field.fieldType === fieldTypes.PERCENT_INPUT) ?
            <PercentInput {...field} key={idx} /> :
            <DecimalInput {...field} key={idx} />))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          className="loan-proceeds-constraints-modal-button lpc-modal-button-cancel"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          className={`loan-proceeds-constraints-modal-button lpc-modal-button-save ${saveIsDisabled && "dsb-disabled"}`}
          onClick={() => handleSave(constraint)}
          disabled={saveIsDisabled}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoanProceedsConstraintsModal;
